import { Component, OnInit } from '@angular/core';
import { CommonapiService } from '../shared/services/commonapi.service';
import * as AOS from 'aos';
import { Title } from "@angular/platform-browser";
//jquery declaration
declare var $: any;


@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

    distributionemaillist: string = '';
    location: string = "Colorado";
    name: string = "";
    company: string = "";
    phone: string = "";
    email: string = "";
    general: boolean = false;
    sp: boolean = false;
    st: boolean = false;
    si: boolean = false;
    AI: boolean = false;
    osha: boolean = false;
    isot: boolean = false;
    other: string = "";
    loc: string = "";
    primary: string = "";
    manager: string = "";
    business: string = "";

    constructor(
        private commonApiService: CommonapiService,
        private titleService: Title,
    ) { }


    async ngOnInit(): Promise<void> {
        this.titleService.setTitle("Contact - SFI Compliance, Inc");
        this.topposition();
        AOS.init();
        $(".mapcontainer").mapael({
            map: {
                name: "usa_states"
                // Set default plots and areas style
                , defaultPlot: {
                    attrs: {
                        fill: "#fff"
                        , opacity: 1
                    }
                    , attrsHover: {
                        opacity: 1
                    }
                    , text: {
                        attrs: {
                            fill: "#fff"
                        }
                        , attrsHover: {
                            fill: "#000"
                        }
                    }
                }
                , defaultArea: {
                    attrs: {
                        fill: "#054a85"
                        , stroke: "#f4f4e8"
                        , opacity: 0.8
                    }
                    , attrsHover: {
                        fill: "#6f89a2"
                    }
                    , text: {
                        attrs: {
                            fill: "#fff"
                        }
                        , attrsHover: {
                            fill: "#000"
                        }
                    }
                }
            },

            legend: {
                area: {
                    title: "Where We Work",
                    slices: [
                        {
                            max: 2,
                            attrs: {
                                fill: "#032d57"
                            },
                            label: "Local Coverage"
                        },
                        {
                            min: 3,
                            max: 5,
                            attrs: {
                                fill: "#FF0000"
                            },
                            label: "Extended Coverage"
                        },
                        {
                            min: 5,
                            max: 10,
                            attrs: {
                                fill: "#808080"
                            },
                            label: ""
                        }
                    ]
                },
                
            },
            areas: {
                "CO": {
                    type: "circle",
                    size: 0,
                    value: "2",
                    latitude: 39.5501,
                    longitude: -105.7821,                    
                    text: {
                        content: "CO"
                    },
                    href: '/colorado'
                },
                "TX": {
                    type: "circle",
                    size: 0,
                    latitude: 31.9686,
                    longitude: -99.9018,
                    value: "3",                    
                    text: { content: "TX" },
                    href: '/texas'
                },
                'AZ': {
                    type: "circle",
                    size: 0,
                    latitude: 34.0489,
                    longitude: -111.0937,
                    value: "2",
                    //tooltip: { content: "<span style=\"font-weight:bold;\">Office :</span> Arizona" },
                    text: { content: "AZ" },
                    href: '/arizona'
                },
                'FL': {
                    type: "circle",
                    size: 0,
                    latitude: 27.994402,                    
                    longitude: -81.760254,                    
                    value: "2",
                    //tooltip: { content: "<span style=\"font-weight:bold;color:#032d57;\"></span>FL" },
                    text: { content: "FL", attrs: { "font-size": 15, fill: "#032d57", opacity: 1 } ,
                    },
                    href: '/florida'
                },
                'WA': {
                    type: "circle",
                    size: 0,
                    latitude: 47.7511,
                    longitude: -120.7401,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> WA" },
                    text: { content: "WA" }
                },
                'OR': {
                    type: "circle",
                    size: 0,
                    latitude: 44.000000,
                    longitude: -120.500000,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> OR" },
                    text: { content: "OR" }
                },
                'CA': {
                    type: "circle",
                    size: 0,
                    latitude: 36.778259,
                    longitude: -119.417931,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> CA" },
                    text: { content: "CA" }
                },
                'NM': {
                    type: "circle",
                    size: 0,
                    latitude: 34.307144,
                    longitude: -106.018066,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> NM" },
                    text: { content: "NM" }
                },
                'OK': {
                    type: "circle",
                    size: 0,
                    latitude: 36.084621,
                    longitude: -96.921387,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> OK" },
                    text: { content: "OK" }
                },
                'AR': {
                    type: "circle",
                    size: 0,
                    latitude: 34.799999,
                    longitude: -92.199997,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> AR" },
                    text: { content: "AR" }
                },
                'AL': {
                    type: "circle",
                    size: 0,
                    latitude: 35.860119,
                    longitude: -86.660156,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> AL" },
                    text: { content: "AL" }
                },
                'SC': {
                    type: "circle",
                    size: 0,
                    latitude: 33.836082,
                    longitude: -81.163727,
                    value: "2",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> SC" },
                    text: { content: "SC" }
                },
                'NC': {
                    type: "circle",
                    size: 0,
                    latitude: 35.782169,
                    longitude: -80.793457,
                    value: "2",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> NC" },
                    text: { content: "NC" },
                    href: '/nc'
                },
                'VA': {
                    type: "circle",
                    size: 0,
                    latitude: 37.926868,
                    longitude: -78.024902,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> VA" },
                    text: { content: "VA" }
                },
                'MN': {
                    type: "circle",
                    size: 0,
                    latitude: 46.392410,
                    longitude: -94.636230,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MN" },
                    text: { content: "MN" }
                },
                'MA': {
                    type: "circle",
                    size: 0,
                    latitude: 39.045753,
                    longitude: -76.641273,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MA" },
                    text: { content: "MA" }
                },
                'TN': {
                    type: "circle",
                    size: 0,
                    latitude: 35.860119,
                    longitude: -86.660156,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> TN" },
                    text: { content: "TN" }
                },
                'ID': {
                    type: "circle",
                    size: 0,
                    latitude: 44.068203,
                    longitude: -114.742043,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>ID" },
                    text: { content: "ID" }
                },
                'MT': {
                    type: "circle",
                    size: 0,
                    latitude: 46.965260,
                    longitude: -109.533691,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MT" },
                    text: { content: "MT" }
                },
                'WY': {
                    type: "circle",
                    size: 0,
                    latitude: 43.075970,
                    longitude: -107.290283,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> WY" },
                    text: { content: "WY" }
                },
                'NV': {
                    type: "circle",
                    size: 0,
                    latitude: 39.876019,
                    longitude: -117.224121,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> NV" },
                    text: { content: "NV" }
                },
                'UT': {
                    type: "circle",
                    size: 0,
                    latitude: 39.419220,
                    longitude: -111.950684,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> UT" },
                    text: { content: "UT" }
                },
                'ND': {
                    type: "circle",
                    size: 0,
                    latitude: 47.650589,
                    longitude: -100.437012,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> ND" },
                    text: { content: "ND" }
                },
                'SD': {
                    type: "circle",
                    size: 0,
                    latitude: 44.500000,
                    longitude: -100.000000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> SD" },
                    text: { content: "SD" }
                },
                'NE': {
                    type: "circle",
                    size: 0,
                    latitude: 41.500000,
                    longitude: -100.000000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> NE" },
                    text: { content: "NE" }
                },
                'KS': {
                    type: "circle",
                    size: 0,
                    latitude: 38.500000,
                    longitude: -98.000000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> KS" },
                    text: { content: "KS" }
                },
                'IA': {
                    type: "circle",
                    size: 0,
                    latitude: 42.032974,
                    longitude: -93.581543,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> IO" },
                    text: { content: "IO" }
                },
                'MO': {
                    type: "circle",
                    size: 0,
                    latitude: 38.573936,
                    longitude: -92.603760,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MO" },
                    text: { content: "MO" }
                },
                'MS': {
                    type: "circle",
                    size: 0,
                    latitude: 33.000000,
                    longitude: -90.000000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MS" },
                    text: { content: "MS" }
                },
                'LA': {
                    type: "circle",
                    size: 0,
                    latitude: 30.391830,
                    longitude: -92.329102,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> LA" },
                    text: { content: "LA" }
                },
                'WI': {
                    type: "circle",
                    size: 0,
                    latitude: 44.500000,
                    longitude: -89.500000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> WI" },
                    text: { content: "WI" }
                },
                'IL': {
                    type: "circle",
                    size: 0,
                    latitude: 40.000000,
                    longitude: -89.000000,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> IL" },
                    text: { content: "IL" }
                },
                'IN': {
                    type: "circle",
                    size: 0,
                    latitude: 40.273502,
                    longitude: -86.126976,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> IN" },
                    text: { content: "IN" }
                },
                'MI': {
                    type: "circle",
                    size: 0,
                    latitude: 44.182205,
                    longitude: -84.506836,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MI" },
                    text: { content: "MI" }
                },
                'OH': {
                    type: "circle",
                    size: 0,
                    latitude: 40.367474,
                    longitude: -82.996216,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> OH" },
                    text: { content: "OH" }
                },
                'KY': {
                    type: "circle",
                    size: 0,
                    latitude: 37.839333,
                    longitude: -84.270020,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> KY" },
                    text: { content: "KY" }
                },
                'WV': {
                    type: "circle",
                    size: 0,
                    latitude: 39.000000,
                    longitude: -80.500000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> WV" },
                    text: { content: "WV" }
                },
                'PA': {
                    type: "circle",
                    size: 0,
                    latitude: 41.203323,
                    longitude: -77.194527,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> PA" },
                    text: { content: "PA" }
                },
                'NY': {
                    type: "circle",
                    size: 0,
                    latitude: 43.000000,
                    longitude: -75.000000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> NY" },
                    text: { content: "NY" }
                },
                'VT': {
                    type: "circle",
                    size: 0,
                    latitude: 44.000000,
                    longitude: -72.699997,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>VT" },
                    text: { content: "VT" }
                },
                'ME': {
                    type: "circle",
                    size: 0,
                    latitude: 45.367584,
                    longitude: -68.972168,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>ME" },
                    text: { content: "ME" }
                },
                'RI': {
                    type: "circle",
                    size: 0,
                    latitude: 41.700001,
                    longitude: -71.500000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>RI" },
                    text: { content: "RI" }
                },
                'CT': {
                    type: "circle",
                    size: 0,
                    latitude: 41.599998,
                    longitude: -72.699997,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> CT" },
                    text: { content: "CT" }
                },
                'NJ': {
                    type: "circle",
                    size: 0,
                    latitude: 39.833851,
                    longitude: -74.871826,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>NJ" },
                    text: { content: "NJ" }
                },
                'NH': {
                    type: "circle",
                    size: 0,
                    latitude: 44.000000,
                    longitude: -71.500000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>NH" },
                    text: { content: "NH" }
                },
                'DE': {
                    type: "circle",
                    size: 0,
                    latitude:39.000000,
                    longitude: -75.500000,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>DE" },
                    text: { content: "DE" }
                },
                'MD': {
                    type: "circle",
                    size: 0,
                    latitude: 39.045753,
                    longitude: -76.641273,
                    value: "3",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span> MD" },
                    text: { content: "MD" }
                },
                // 'DC': {
                //     type: "circle",
                //     size: 0,
                //     latitude: 38.942142,
                //     longitude: -77.025955,
                //     value: "6",
                //     //tooltip: { content: "<span style=\"font-weight:bold;\"></span> DC" },
                //     text: { content: "DC" }
                // },
                'GA': {
                    type: "circle",
                    size: 0,
                    latitude: 33.247875,
                    longitude: -83.441162,
                    value: "2",
                    //tooltip: { content: "<span style=\"font-weight:bold;color:#032d57;\"></span>GA" },
                    text: { content: "GA" }
                },                
                'AK': {
                    type: "circle",
                    size: 0,
                    latitude: 66.160507,
                    longitude: -153.369141,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>AK" },
                    text: { content: "AK" }
                },
                'HI': {
                    type: "circle",
                    size: 0,
                    latitude: 19.741755,
                    longitude: -155.844437,
                    value: "6",
                    //tooltip: { content: "<span style=\"font-weight:bold;\"></span>HI" },
                    text: { content: "HI", attrs: { "font-size": 15, fill: "#032d57", opacity: 1 } }
                },               
            }
        });

        let _dt = await this.commonApiService.getData("api/MarketingApi/DBGetDistributionList/").toPromise();

        if (_dt && _dt[0].dataSet && _dt[0].dataSet.emailList) {
            console.log(_dt[0].dataSet.emailList);
            this.distributionemaillist = _dt[0].dataSet.emailList;
        }
    }

    //scroll to top of the page automatically
    topposition() {

        // if ($('#preloader').length) {
        //   $('#preloader').delay(500).fadeOut('slow', function() {
        //     $(this).remove();
        //   });
        // }
        $('html, body').animate({
            scrollTop: 0
        }, 1000, 'easeInOutExpo');

        return false;
    }

    bottomscroll(){
        console.log("bottomscroll");
        $('html, body').animate({
            scrollTop:$("#contact").offset().top
        }, 1000, 'easeInOutExpo');

    }

    ValidateEmail(mail) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return (true)
        }
        return (false)
    }

    async sendmessage() {

        if (this.name === "") {
            alert("Please Enter Your Name");
            document.getElementById("name").focus();
            return;
        }
        else if (this.company === "") {
            alert("Please Enter Your Company");
            document.getElementById("company").focus();
            return;
        }
        else if (this.email === "") {
            alert("Please Enter Your Email Address");
            document.getElementById("email").focus();
            return;
        }
        else if (this.email !== "" && this.ValidateEmail(this.email) === false) {
            alert("Please Enter Valid Email Address");
            document.getElementById("email").focus();
            return;
        }
        else if (this.phone === "") {
            alert("Please Enter Your Phone Number");
            document.getElementById("phone").focus();
            return;
        }
        if (this.general === false && this.sp === false && this.st === false && this.si === false && this.AI === false && this.osha === false && this.isot === false && this.other === "") {
            alert("Please Select Type of Service");
            return;
        }
        else if (this.primary === "") {
            alert("Please Enter Your Primary Location");
            document.getElementById("primary").focus();
            return;
        }
        else if (this.business === "") {
            alert("Please Enter Your Business");
            document.getElementById("business").focus();
            return;
        }
        else {
            var _selected = "";

            if (this.general === true) {
                _selected += "General";
            }

            if (this.sp === true) {
                _selected += (_selected !== "" ? "," : "") + " Safety Program";
            }

            if (this.st === true) {
                _selected += (_selected !== "" ? "," : "") + " Safety Training";
            }

            if (this.si === true) {
                _selected += (_selected !== "" ? "," : "") + " Safety Inspections";
            }

            if (this.AI === true) {
                _selected += (_selected !== "" ? "," : "") + " Accident Investigations";
            }

            if (this.osha === true) {
                _selected += (_selected !== "" ? "," : "") + " OSHA Informal Conference Assistance";
            }

            if (this.isot === true) {
                _selected += (_selected !== "" ? "," : "") + " Other" + (this.other !== "" ? "-" + this.other : "");
            }

            const _obj = {
                EmailList: this.distributionemaillist,
                Subject: this.name + " contacted SFI using Marketing Website Email from " + this.email,
                Body: "<p>Hi SFI,</p><p>Name: " + this.name + "</p><p>Organization: " + this.company + "</p>" +
                    "<p>Email: " + this.email + "</p><p>Phone: " + this.phone + ",</p><p>Selected services are :</p>" +
                    _selected + "<p>location:" + this.loc + "</p><p>primary location:" + this.primary + "</p><p>safety manager:" + this.manager + "</p>" +
                    "<p>business: " + this.business + "</p><p>Regards,</p><p>" + this.name + "</p><p>&nbsp;</p>",
            };
            console.log(_obj);
            let _dt = await this.commonApiService.postData("api/MarketingApi/EmailNotification/", _obj).toPromise();

            if (_dt && _dt[0].dataSet) {
                alert(_dt[0].dataSet);
                if (_dt[0].dataSet === "Email Sent Successfully") {
                    this.name = "";
                    this.company = "";
                    this.phone = "";
                    this.email = "";
                    this.general = false;
                    this.sp = false;
                    this.st = false;
                    this.si = false;
                    this.AI = false;
                    this.osha = false;
                    this.isot = false;
                    this.other = "";
                    this.loc = "";
                    this.primary = "";
                    this.manager = "";
                    this.business = "";
                }
            }
        }

    }
}

